import { Box, styled } from "@mui/material";

export const DetailContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    overflow: "hidden",
}));
